import { render } from "./platform_customer_se.vue?vue&type=template&id=7d46b0aa&ts=true"
import script from "./platform_customer_se.vue?vue&type=script&lang=ts"
export * from "./platform_customer_se.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__